<template>
  <div id="HomePage">
    <!-- 轮播图 -->
    <div id="swiper" class="container-fuild">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in swiperList" :key="index">
            <img class="swiper-lazy" :data-src="item.img" alt="轮播图">
            <div class="swiper-lazy-preloader"></div>
            <div class="swiper-slide-title">
                <h1>{{item.title}}</h1>
                <p>{{item.content}}</p>
            </div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
    <!-- 产品列表 -->
    <div id="productData" class="container-fuild"
      v-for="(item,index) in productList"
      :key="index"
    >
      <div class="row productData-container">
        <div class="col-xs-12 col-sm-12 col-md-6 wow zoomIn">
          <img class="img-responsive" :src="item.img" :alt="item.title">
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6">
          <h2 class="productData-title">
            {{item.title}}
            <small>/ {{item.titleEn}}</small>
          </h2>
          <p>{{ item.desc }}</p>
          <a :href="item.downloadAndrod" class="btn btn-lg btn-block btn-info">安卓下载</a>
          <img class="img-qr hidden-xs" width="211" height="211" :src="item.downloadQr" alt="二维码下载">
        </div>
      </div>
    </div>
    <!-- 客户评价 -->
    <div id="customer" class="container-fuild">
      <div class="container customer-container">
        <p class="customer-title text-center">客户评价</p>
        <div class="swiper-container customer-swiper hidden-xs">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide customer-block"
              v-for="(item,index) in customerList"
              :key="index"
            >
              <div class="customer-logo">
                <img class="center-block" :src="item.logo" alt="logo">
              </div>
              <div class="customer-yh">
                <img src="@/assets/img/yinhao.png" alt="引号">
              </div>
              <div class="customer-content1">
                <small>{{item.content}}</small>
              </div>
              <div class="customer-content2">{{item.title}}</div>
            </div>
          </div>
          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
        <div class="row visible-xs customer-block">
          <div class="col-xs-12" v-for="(item,index) in customerList" :key="index">
            <div class="customer-logo">
              <img class="center-block" :src="item.logo" alt="logo">
            </div>
            <div class="customer-yh">
              <img src="@/assets/img/yinhao.png" alt="引号">
            </div>
            <div class="customer-content1">
              <small>{{item.content}}</small>
            </div>
            <div class="customer-content2">
              <small>{{item.title}}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 为什么选择我们 -->
    <div id="whyChooseUs" class="conatiner-fuild">
      <div class="container">
        <div class="whyChooseUs-title text-center">
          <p>为什么选择我们的服务</p>
          <p>THE REASON TO CHOOSING US</p>
        </div>
        <div class="row">
          <div
            class="col-xs-12 col-sm-6 col-md-3 server-wrapper"
            v-for="(item,index) in serverList"
            :key="index"
          >
            <div
              class="server-block wow slideInUp"
              onmouseenter="this.style.color='#28f';this.style.borderColor='#28f'"
              onmouseleave="this.style.color='#666';this.style.borderColor='#ccc'"
            >
              <img class="center-block" :src="item.logo" alt="logo">
              <p class="text-center">{{item.title}}</p>
              <div
                class="text-center"
                v-html="item.content"
                onmouseenter="this.style.color='#28f'"
                onmouseleave="this.style.color='#ccc'"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { WOW } from 'wowjs';
export default {
  name: "HomePage",
  data() {
    return {
      productList: [
        {
          img:require("@/assets/img/app_global_trans.jpg"),
          title:"全球语音翻译APP",
          titleEn:"Global voice translation",
          desc:"全球通语音翻译器，这是一款专为全球旅行者、商务人士以及语言学习者设计的智能语音翻译工具。它支持超过140个国家和地区的语言互译，无论您身处世界何地，都能轻松实现无障碍沟通。",
          downloadQr:require("@/assets/img/download_qr_paopao.png"),
          downloadAndrod:"https://fanyi.qj-it.com/soft_versions/17.apk",
        },
        {
          img:require("@/assets/img/app_zuowenbao.png"),
          title:"AI作文宝APP",
          titleEn:"AI Writing Master",
          desc:"写作文没有思路？不知道如何批改作文？AI作文宝来帮忙！AI智能写作——按要求创作出高质量的内容；作文指导——多维度给出写作思路；作后批改——智能纠错，并给出改进建议",
          downloadQr:require("@/assets/img/download_qr_paopao.png"),
          downloadAndrod:"https://fanyi.qj-it.com/soft_versions/17.apk",
        },
        {
          img:require("@/assets/img/app_screen.png"),
          title:"屏幕翻译君APP",
          titleEn:"Screen Translate Master",
          desc:"屏幕翻译君是一款可自动翻译屏幕的软件，支持悬浮框一键翻译，操作简单，可以一边玩游戏一边翻译，支持多种翻译引擎，智能文字识别，原文覆盖、翻译精准、速度快。同时支持漫画翻译、照片翻译、输入翻译等。深受广大外服游戏玩家和漫画爱好者的喜爱。",
          downloadQr:require("@/assets/img/download_qr_paopao.png"),
          downloadAndrod:"https://fanyi.qj-it.com/soft_versions/20.apk",
        },
        {
          img:require("@/assets/img/app_zimu.png"),
          title:"视频翻译器APP",
          titleEn:"Audio Translate Master",
          desc:"视频翻译器是专门针对海外电影和电视剧无字幕或者外语字幕开发的字幕翻译软件，可以自动识别并翻译外语字幕，也可以通过语音识别并同步生成中文字幕",
          downloadQr:require("@/assets/img/download_qr_paopao.png"),
          downloadAndrod:"https://fanyi.qj-it.com/soft_versions/17.apk",
        }
      ],
      swiperList: [
        {
          img: require("@/assets/img/banner_1.jpg"),
          path: "",
          title: '全球语音翻译',
          content: '支持全球140+国家和地区语言翻译，识别精准、极速翻译',
        },
        {
          img: require("@/assets/img/banner_1.jpg"),
          path: "",
          title: '屏幕翻译君',
          content: '一键翻译屏幕上的文字，游戏、漫画、网页、图片实时翻译',
        },
        {
          img: require("@/assets/img/banner_2.jpg"),
          path: "",
          title: '视频翻译器',
          content: '视频一键同步中文字幕，支持语音生成字幕',
        },
        {
          img: require("@/assets/img/banner_com.jpg"),
          path: "",
          title: 'AI作文宝',
          content: '作文批改与智能写作',
        }
      ],
      customerList: [
        {
          logo: "https://art-figner.oss-cn-shanghai.aliyuncs.com/fanyi/users/avatar/2023112311655ec09705b75.jpg?x-oss-process=image/resize,m_fixed,h_120,w_120",
          title:
            "哈哈，这个翻译好，速度很快，翻译的内容也很精彩",
          content:
            "多国语言都支持，追剧神奇啊，再也没有语言困扰啦"
        },
        {
          logo: "https://art-figner.oss-cn-shanghai.aliyuncs.com/fanyi/users/avatar/2023112310655ebeadd5edd.jpg?x-oss-process=image/resize,m_fixed,h_120,w_120",
          title:
            "语音翻译做的很好，同步很快，到期了续费个永久会员",
          content:
            "之前太多剧情看不懂，有了翻译器现在轻松多了"
        },
        {
          logo: "https://art-figner.oss-cn-shanghai.aliyuncs.com/fanyi/users/avatar/20230919226509b1cd04966.jpg?x-oss-process=image/resize,m_fixed,h_120,w_120",
          title:
            "太方便了，可以后台运行，不需要切换app，一键悬浮窗翻译真的好评",
          content:
            "怎么早没发现这样的翻译神器，太方便啦，哈哈"
        }
      ],
      serverList: [
        {
          logo: require("@/assets/img/skill.png"),
          title: "OCR识别技术",
          content: "<p>头部图像识别</p>识别率遥遥领先"
        },
        {
          logo: require("@/assets/img/computer.png"),
          title: "智能翻译",
          content: "<p>神经网络翻译技术</p>智能翻译，翻译更精准"
        },
        {
          logo: require("@/assets/img/qq.png"),
          title: "悬浮窗",
          content: "<p>开启悬浮窗权限</p>一键翻译屏幕上的外文"
        },
        {
          logo: require("@/assets/img/tel.png"),
          title: "客服1V1",
          content: "<p>由专业客服提供人工服务</p>负责疑难问题和故障受理"
        }
      ]
    };
  },
  mounted() {
    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true, // 循环模式选项
      effect: 'fade',
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
    /* customer-swiper */
    new Swiper(".customer-swiper", {
      loop: true, // 循环模式选项
      slidesPerView: 3,
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    })
    wow.init();
  }
};
</script>
<style scoped>
/* 整体盒子 */
#HomePage {
  width: 100%;
}

/* 轮播图 */
#swiper {
  height: 600px;
}
#swiper .banner-swiper {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide{
  position: relative;
}
#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(51, 51, 51, 0.534);
  text-align: center;
  line-height: 80px;
}
#swiper .banner-swiper .swiper-slide-title > h1{
  font-size: 50px;
  margin-top: 12%;
}
#swiper .banner-swiper .swiper-slide-title > p{
  font-size: 20px;
  margin-top: 1%;
  font-weight: 700;
}
/* 产品列表 */
#productData {
  padding: 100px;
  transition: all ease 0.6s;
  box-sizing: border-box;
}

#productData .productData-title {
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
#productData p {
  font-size: 14px;
  color: #333;
  line-height: 2rem;
}
#bigproductDataData .productData-device {
  margin: 50px 0 20px;
}
#productData .img-qr{
  margin: 20px 0 0 30%;
}

/* 您身边的IT专家 */
#contactUs {
  color: #fff;
  height: 400px;
  background: url("../assets/img/contact_us_bg.jpg") 0 0 no-repeat;
  background-size: 100% 100%;
  transition: all ease 0.6s;
}
#contactUs .contactUs-container {
  padding-top: 50px;
}
#contactUs .contactUs-container button {
  width: 300px;
  height: 50px;
  margin-top: 40px;
}
#contactUs .contactUs-container .contactUs-contactWay span {
  display: inline-block;
  width: 48px;
  height: 48px;
  margin: 30px;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(1) {
  background: url("../assets/img/weixin.png") 0 0 no-repeat;
  background-size: 100% 100%;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(2) {
  background: url("../assets/img/weibo.png") 0 0 no-repeat;
  background-size: 100% 100%;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(3) {
  background: url("../assets/img/twitter.png") 0 0 no-repeat;
  background-size: 100% 100%;
}

/* 客户评价 */
#customer {
  padding: 50px 0;
  box-sizing: border-box;
  background: #efefef;
  transition: all ease 0.6s;
}
#customer .customer-title {
  font-size: 30px;
  color: rgb(102, 102, 102);
  margin: 0 0 30px;
}
#customer .customer-block {
  background: #fff;
  padding: 30px;
}
#customer .customer-logo img {
  width: 94px;
  height: 94px;
  border: 1px solid #ccc;
}
#customer .customer-yh img {
  width: 34px;
  height: 34px;
}
#customer .customer-content1 {
  padding-bottom: 20px;
  border-bottom: 1px solid #0ce9f1;
}
#customer .customer-content2 {
  padding-top: 20px;
}
/* 为什么选择我们 */
#whyChooseUs {
  padding: 100px;
}
#whyChooseUs .whyChooseUs-title {
  margin-bottom: 50px;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
  font-size: 25px;
  font-weight: 500;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
  font-size: 14px;
}
#whyChooseUs .server-block {
  padding: 50px 20px;
  border: 1px solid #ccc;
  border-bottom: 5px solid #ccc;
}
#whyChooseUs .server-block img {
  width: 48px;
  height: 48px;
}
#whyChooseUs .server-block > p {
  font-size: 20px;
  margin: 30px 0;
}
#whyChooseUs .server-block > div {
  color: #ccc;
}
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  #swiper {
    height: 200px;
  }
  #productData {
    padding: 30px;
  }
  #productData .productData-title {
    font-size: 20px;
  }
  #productData .productData-device {
    font-size: 20px;
    margin: 10px 0 10px;
  }
  #contactUs {
    height: 200px;
    transition: all ease 0.6s;
  }
  #contactUs .contactUs-container {
    padding-top: 0;
  }
  #contactUs .contactUs-container h1 {
    font-size: 25px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 18px;
  }
  #contactUs .contactUs-container button {
    width: 200px;
    height: 30px;
    margin-top: 20px;
  }
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin: 10px;
  }
  #customer {
    padding: 30px 0;
    box-sizing: border-box;
    background: #fff;
  }
  #customer .customer-title {
    font-size: 16px;
    font-weight: bold;
  }
  #customer .customer-logo img {
    width: 48px;
    height: 48px;
  }
  #customer .customer-block {
    padding: 30px;
  }
  #customer .customer-block > div {
    padding: 30px 0;
  }
  #whyChooseUs {
    padding: 20px 0;
    transition: all ease 0.6s;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
    font-size: 20px;
    font-weight: 700;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
    font-size: 12px;
  }
  #whyChooseUs .server-block {
    padding: 50px 0;
    border: 1px solid #ccc;
    border-bottom: 5px solid #ccc;
  }
  #whyChooseUs .server-block img {
    width: 48px;
    height: 48px;
  }
  #whyChooseUs .server-block > p {
    font-size: 20px;
    margin: 30px 0;
  }
  #whyChooseUs .server-block > div {
    color: #ccc;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #swiper {
    height: 400px;
  }
  #productData {
    padding: 60px;
  }
  #productData .productData-title {
    font-size: 30px;
  }
  #productData .productData-device {
    font-size: 30px;
    margin: 30px 0 15px;
  }
  #contactUs {
    height: 300px;
  }
  #contactUs .contactUs-container {
    padding-top: 50px;
  }
  #contactUs .contactUs-container h1 {
    font-size: 30px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 20px;
  }
  #contactUs .contactUs-container button {
    width: 300px;
    height: 50px;
    margin-top: 30px;
  }
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 32px;
    height: 32px;
    margin: 15px;
  }
  #customer .customer-title {
    font-size: 24px;
  }
  #whyChooseUs {
    padding: 20px 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/HomePage.vue